// @flow weak

/* eslint no-console: 0 */
import React      from 'react';
import PropTypes  from 'prop-types';
import cx         from 'classnames';
import UserPanel  from './userPanel/UserPanel';
import LocationMenu2  from '../../locationMenu/LocationMenu2';
import SearchForm from './searchForm/SearchForm';
import Horloge    from '../../horloge/Horloge';
import Menu       from './menu/Menu';


const AsideLeft = ({
  reloadData,
  locationMenu,
  connectionStatus,
  userIsConnected,
  username,
  helloWord,
  userPicture,
  showPicture,
  isAnimated,
  isCollapsed,
  currentView,
  sideMenu,
  user,
  notifications,
  accessConfig
}) => (
  <aside
    className={
      cx({
        'no-print':          true,
        'left-side':         true,
        'aside-left--fixed': true,
        'sidebar-offcanvas': true,
        'sidebar-animated':  isAnimated,
        'collapse-left':     isCollapsed
      })
    }
    // add overflow to left sidebar:
    style={{
      height:   '100%',
      overflow: 'auto',
      position: 'fixed'
    }}
  >
    <section className="sidebar">

      <LocationMenu2 data={locationMenu} access={accessConfig} user={user} notifications={notifications} reloadData={reloadData}/>

    </section>
  </aside>
);
{/*
AsideLeft.propTypes = {
  isAnimated:   PropTypes.bool,
  isCollapsed:  PropTypes.bool,
  sideMenu:     PropTypes.arrayOf(
    PropTypes.shape({
      id:     PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      group:  PropTypes.string.isRequired,
      menus:  PropTypes.arrayOf(
        PropTypes.shape({
          name:       PropTypes.string.isRequired,
          linkTo:     PropTypes.string.isRequired,
          faIconName: PropTypes.string.isRequired
        })
      )
    })
  ).isRequired,
  currentView:      PropTypes.string,
  connectionStatus: PropTypes.shape({
    online:         PropTypes.string,
    disconnected:   PropTypes.string
  }),
  userIsConnected:  PropTypes.bool,
  username:         PropTypes.string,
  userPicture:      PropTypes.any,
  showPicture:      PropTypes.bool,
  helloWord:        PropTypes.string
};
*/}
AsideLeft.defaultProps = {
  isAnimated:   false,
  isCollapsed:  false
};

export default AsideLeft;



// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/AsideLeft.js